import React from "react";
import "./AttendenceReport.scss";
import { Spin, Table, Tag, Button } from "antd";
import { formatDate } from "../../utils/dateFormatter";
import useAttendanceReport from "./logic/useAttendanceReport";
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle";
import Mouse from "../../components/Mouse/Mouse";
import ScrollTop from "../../components/ScrollTop/ScrollTop";

const AttendenceReport = () => {
  const { data, isFetching, navigateToAttendancesReport } = useAttendanceReport();

  if (isFetching) {
    return (
      <div className="no-data-message">
        <Spin />
      </div>
    );
  }

  const sessionDates = [
    ...new Set(
      data.attendancesReport.reduce((dates, record) => {
        return dates.concat(record.sessions.map((session) => session.date));
      }, [])
    ),
  ];

  const maxSessions = Math.max(
    ...data.attendancesReport.map((record) =>
      Math.max(...record.sessions.map((session) => session.items.length))
    )
  );

  const transformData = (data) => {
    return data.map((record) => {
      const transformedRecord = {
        key: record.user.id,
        user: record.user,
      };

      record.sessions.forEach((session) => {
        const sortedItems = session.items.sort(
          (a, b) => new Date(a.from) - new Date(b.from)
        );

        sortedItems.forEach((item, index) => {
          const dateKey = item.date;
          if (!transformedRecord[dateKey]) {
            transformedRecord[dateKey] = [];
          }

          transformedRecord[dateKey].push({
            ...item,
            session: index + 1, // Session number
          });
        });
      });

      return transformedRecord;
    });
  };

  const transformedData = transformData(data.attendancesReport);

  const dateColumns = sessionDates.map((date) => ({
    title: formatDate(date),
    dataIndex: date,
    key: date,
    render: (text, record) => {
      const sessionData = record[date];
      const sessions = sessionData ? sessionData.map((item, index) => (
        <div key={`${item.id}-${index}`} className="session">
          <span className="attendance">
            <div className="time">
              {item.from} to {item.to}
            </div>
            <Tag
              style={{
                borderColor:
                  item.attendances[0].status === "present" ? "green" : "gray",
                color:
                  item.attendances[0].status === "present"
                    ? "green"
                    : "default",
              }}
              className="status"
            >
              {item.attendances[0].status}
            </Tag>
          </span>
        </div>
      )) : [];

      // Fill remaining slots with "-------"
      const remainingSessions = Array.from(
        { length: maxSessions - sessions.length },
        (_, index) => (
          <div key={`empty-${index}`} className="session empty-session">
            -------------
          </div>
        )
      );

      return <div>{sessions.concat(remainingSessions)}</div>;
    },
  }));

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: "auto",
      render: (text, record) => (
        <div className="user">
          {record.user.firstName} {record.user.lastName}
        </div>
      ),
    },
    {
      title: "Session",
      dataIndex: "session",
      key: "session",
      fixed: "left",
      width: "auto",
      render: (text, record) => (
        <div>
          {Array.from({ length: maxSessions }, (_, index) => (
            <div key={`session-${index + 1}`} className="session">
              Session {index + 1}
            </div>
          ))}
        </div>
      ),
    },
    ...dateColumns,
  ];

  return (
    <>
      <FlatTitle pageName={"Attendance Report"} />
      <div className="section-container">
        <div id="wrapper">
          <div className="attendence_header_title">
            <h2>{data.courseTitle} Training</h2>
          </div>
          <div className="attendence_header">
            <p>Total Participants: {transformedData.length} </p>
            <Button className="edit_button" onClick={navigateToAttendancesReport}>
              Edit
            </Button>
          </div>
          {isFetching ? (
            <div className="no-data-message">
              <Spin />
            </div>
          ) : transformedData.length === 0 ? (
            <div className="no-data-message">No data</div>
          ) : (
            <div className="attendence_table">
              <Table
                className="ant-table-scroll"
                columns={columns}
                dataSource={transformedData}
                pagination={false}
                rowClassName="attendance-row"
              />
            </div>
          )}
          <Mouse />
          <ScrollTop />
        </div>
      </div>
    </>
  );
};

export default AttendenceReport;
